export enum RecordStatuses {
    New = 1,
    Amended = 2,
    Repealed = 3,
    Draft = 4,
    EmergencyRenewed = 5
}